import { WithStyles, createStyles, Typography, Grid } from '@material-ui/core';
import { Theme } from '@material-ui/core';

let styles
export default styles = (theme: Theme) => createStyles({
    customCard: {
        background: '#FFF',
        boxShadow: '0px 0px 10px rgb(0 0 0 / 10%)',
        borderRadius: 8,
        marginBottom: 24,
        padding: 24,
    },
    testName: {
        fontSize: 20,
        color: '#666',
        fontWeight: 400,
        marginBottom: 20,
        '& span': {
            fontWeight: 700,
        }
    },
    subjectName: {
        fontSize: 16,
        color: '#666',
        fontWeight: 400,
        '& span': {
            fontWeight: 700,
        }
    },
    orderNotes: {
        fontSize: 16,
        color: '#1d7dea',
        backgroundColor: 'rgba(29, 125, 234, 0.08)',
        fontWeight: 600,
        borderRadius: 4,
        padding: '2px',
        height: 28,
        width: 129,
        textAlign: 'center',

    },
    orderBy: {
        fontSize: 14,
        color: '#999',
        fontWeight: 600,
        '& span': {
            color: '#515C65'
        }
    },
    headingText: {
        fontSize: 20,
        fontWeight: 700,
        color: '#666',
        marginBottom: 18,
        marginTop: 16,
    },
    normalText: {
        fontSize: 14,
        fontWeight: 400,
        color: '#666'
    },
    maxHeight4: {
        maxHeight: 400,
    },
    image: {
        padding: 15,
    },
    flexDiv:{
        display: 'flex',
        alignItems: 'center',
    },
    linearProgressStyle:{
        minWidth: '85px',
        margin: '0 5px',
        display: 'flex',
    },
    noWrapGoal:{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});
